<style scoped lang="less">
.table-title{
    margin-bottom: 20px;
}
</style>
<template>
  <div>
  
      
        <div class="table table-title">
          <el-table :data="titleTableData" stripe size="mini" border>
            <el-table-column label="SID" prop="sid" align="center" width="280"></el-table-column>
            <el-table-column label="累计流量(单位：m³)" v-if="titleTableData[0].max_flow!==null" prop="max_flow" align="center"></el-table-column>
            <el-table-column label="更新时间" prop="data_time" align="center"></el-table-column>
          </el-table>
        </div>  
        <div class="table">
          <el-table :data="tableData" stripe size="mini" border>
            <el-table-column label="核素名" prop="nuclide" align="center" width="280"></el-table-column>
            <el-table-column label="活度(单位：Bq)" prop="activityStr" align="center"></el-table-column>
            <el-table-column label="探测限（单位：Bq）" prop="detect_value" align="center"></el-table-column>
            <el-table-column  label="活度浓度(单位：Bq/m³)" v-if="titleTableData[0].max_flow" prop="activity_per_flow" align="center"></el-table-column>
          </el-table>
        </div>
 
  </div>
</template>
<script>
export default {
  name: "nuclideTable",
  props: {
    tableData: Array,
    titleTableData: Array
  },
  data() {
    return {
        titleTable:[]
    //   pageLoading: false,
    };
  },
  created(){
     
  },
  //   props: ['noDataObj'],
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/nuclideTable.vue